import React from 'react';
import { Container } from '@pwskills/rachnaui';
import Faqs from '@/components/common/Faqs';
import useMasterclassDescriptionStore from '@/store/MasterClassDescription/useMasterclasDescriptionStore';
import { IMasterclassDescription } from '@/interfaces/masterclassDescription';
import { FAQ_TYPES } from '@/utils/common/common.constants';

const Faq = () => {
  const masterclassDetails = useMasterclassDescriptionStore(
    (state: { masterclassDetails: IMasterclassDescription }) => state.masterclassDetails
  );
  const faq = masterclassDetails?.faq || [];
  return (
    <div className="bg-blue-50">
      {faq && faq?.length > 0 && (
        <Container className="py-8 medium:py-12 large:!py-14 !px-4 medium:!px-8 large:!px-20 ">
          <Faqs
            faqsList={faq}
            classes="flex justify-start large:!justify-center regular:!w-full !text-6 !leading-9  large:!text-8 large:!leading-10 "
            showViewAllButton={false}
            wrapperClass="[&>header]:!pb-[32px] [&>header]:medium:!pb-[36px] [&>header]:large:!pb-[36px] bg-blue-50"
            type={FAQ_TYPES.ACCORDION}
            accordionWrapperClass="bg-white"
          />
        </Container>
      )}
    </div>
  );
};

export default Faq;
